// extracted by mini-css-extract-plugin
export var required = "_go-0";